import { Component, OnInit } from '@angular/core';
import {PedidosService} from "../../services/pedidos.service";
import {GrupolojasService} from "../../superadmin/services/grupolojas.service";
import {IOperacoesModuloPedidos} from "../../superadmin/services/ioperacoesmodulopedidos";
import {ModalKendo} from "../../lib/ModalKendo";

@Component({
  selector: 'app-modal-pedido-status',
  templateUrl: './modal-pedido-status.component.html',
  styleUrls: ['./modal-pedido-status.component.scss']
})
export class ModalPedidoStatusComponent extends ModalKendo implements OnInit {
  private _pedido: any = {};
  set pedido(val: any) {
    this._pedido = val || {};
    this.apliqueDadosDoPedido(this._pedido);
    this.carreguePedidoCompletoQuandoPossivel();
  }
  get pedido() {
    return this._pedido;
  }
  contato: any = {};
  empresa: any = {};
  idEmpresa: any;
  novoStatus: any;
  modoGrupoLojas: boolean
  exibirApenasAtualizarEntregador: boolean
  entregadores: any;
  private inicializado = false;
  private carregandoPedido = false;
  private guidPedidoCarregado: string;


  constructor(private  grupolojasService: GrupolojasService,
              private  pedidosService: PedidosService) {
    super()
  }

  ngOnInit(): void {
    this.inicializado = true;
    this.apliqueDadosDoPedido(this.pedido);
    this.carreguePedidoCompletoQuandoPossivel();
  }


  alterouStatusPedido(erro){
    if(!erro){
      this.fecheModal(this.pedido)
    }
  }

  getService(): IOperacoesModuloPedidos {
    if (this.modoGrupoLojas)
      return this.grupolojasService;

    return this.pedidosService;
  }

  private carreguePedidoCompletoQuandoPossivel() {
    if(!this.inicializado || this.carregandoPedido) return;

    const guid = this.pedido?.guid;
    const idEmpresa = this.obtenhaIdEmpresaPedido();
    if(!guid) return;
    if(this.modoGrupoLojas && !idEmpresa) return;
    if(this.guidPedidoCarregado === `${guid}:${idEmpresa || ''}`) return;

    this.carregandoPedido = true;
    this.guidPedidoCarregado = `${guid}:${idEmpresa || ''}`;

    this.getService().obtenhaPorGuid(guid, idEmpresa).then((pedido) => {
      this._pedido = pedido && pedido.id ? pedido : (this.pedido || {});
      this.apliqueDadosDoPedido(this._pedido);
      this.carregandoPedido = false;
    }).catch(() => {
      this.carregandoPedido = false;
    });
  }

  private apliqueDadosDoPedido(pedido: any) {
    if(!pedido) return;

    this.contato = pedido.cliente || pedido.contato || this.contato;
    this.empresa = pedido.empresa || this.empresa;

    if(!this.idEmpresa)
      this.idEmpresa = pedido.empresa?.id;
  }

  private obtenhaIdEmpresaPedido() {
    return this.idEmpresa || this.pedido?.empresa?.id || this.empresa?.id;
  }

}
